module.exports = __webpack_public_path__ + "static/img/balzw808.6dea043.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/balzw808.jpg
// module id = MDaS
// module chunks = 0